module.exports = __webpack_public_path__ + "img/nhan-ket-qua-icon.e616d514.svg";